import { Parser } from '@json2csv/plainjs';
import { Json2CSVBaseOptions } from '@json2csv/plainjs/BaseParser.js';

interface SaveAsCSVOptions
    extends Omit<Json2CSVBaseOptions<object, object>, 'ndjson'> {
    name?: string;
}

export const saveAsCSV = (data: object[], options: SaveAsCSVOptions = {}) => {
    const { name, ...parseOptions } = options;
    const parser = new Parser({ withBOM: true, ...parseOptions });
    const csv = parser.parse(data);
    const blob = new Blob([csv], {
        type: 'text/csv;charset=utf-8;',
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${name || 'data'}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
